export const { INITIAL_STEP, NONCE } = window.awpcpOnboardingWizardVars;

export const PREFIX = 'awpcp-onboarding';
export const HIDDEN_CLASS = 'hidden';
export const HIDE_JS_CLASS = 'awpcp-hide-js';
export const CURRENT_CLASS = 'awpcp-current';
export const OPEN_CLASS = 'awpcp-open';

export const STEPS = {
	INITIAL: INITIAL_STEP,
	SUCCESS: 'success',
};
